import {
  Button,
  Checkbox,
  Divider,
  Flex,
  Form,
  Grid,
  Input,
  Typography,
  theme,
} from "antd";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useState } from "react";
import { FiUser } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { SignInGoogle } from "../../components/signin-flow/SignInGoogle";
import { ThemeSwitcher, useTheme } from "../../providers/ThemeProvider";

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text, Title, Link } = Typography;

export function SignIn() {
  const { message } = useTheme();
  const { token } = useToken();
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [isLogging, setLogging] = useState<boolean>(false);
  const { theme } = useTheme();

  return (
    <div
      style={{
        width: screens.lg ? "50%" : "100%",
        minWidth: "320px",
        height: "100%",
        backgroundColor: token.colorBgContainer,
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          margin: "0 auto",
          padding: screens.md
            ? `${token.paddingXL}px`
            : `${token.sizeXXL}px ${token.padding}px`,
          width: "380px",
        }}
      >
        <div style={{ position: "absolute", top: "20px", left: "46.5%" }}>
          <ThemeSwitcher />
        </div>
        <div
          style={{
            marginBottom: token.marginXL,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={
              theme == "DARK"
                ? "/assets/logo_dark.png"
                : "/assets/logo_white.png"
            }
            alt=""
            style={{
              width: "97px",
            }}
          />
        </div>
        <div
          style={{
            marginBottom: token.marginXXL,
          }}
        >
          <Title
            style={{
              fontSize: screens.md
                ? token.fontSizeHeading2
                : token.fontSizeHeading3,
              textAlign: "center",
            }}
          >
            Log in
          </Title>
        </div>
        <Form
          name="normal_login"
          initialValues={{
            remember: true,
          }}
          onFinish={({ email, password }) => {
            if (isLogging) return;

            setLogging(true);

            signInWithEmailAndPassword(getAuth(), email, password)
              .then(() => {
                setLogging(false);
              })
              .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(errorCode, errorMessage);
                setLogging(false);
                if (errorCode == "auth/user-not-found") {
                  message.error("User not found");
                } else if (errorCode == "auth/wrong-password") {
                  message.error("Wrong password");
                } else {
                  message.error(errorMessage);
                }
              });
          }}
          layout="vertical"
          requiredMark="optional"
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[
              {
                type: "email",
                required: true,
                message: "Please input your Email!",
              },
            ]}
          >
            <Input
              prefix={<FiUser color={token.colorIcon} size="16px" />}
              placeholder="email"
            />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[
              {
                required: true,
                message: "Please input your Password!",
              },
            ]}
          >
            <Input.Password type="password" placeholder="Password" />
          </Form.Item>
          <Form.Item>
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>Remember me</Checkbox>
            </Form.Item>
            <Link
              style={{
                float: "right",
                color: token.colorPrimary,
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                navigate("/recovery");
              }}
              href="recovery"
            >
              Forgot password?
            </Link>
          </Form.Item>
          <Form.Item style={{ marginBottom: "0px" }}>
            <Button
              loading={isLogging}
              block={true}
              type="primary"
              htmlType="submit"
              style={{ boxShadow: `0 2px 0 ${token.boxShadow}` }}
            >
              Log in
            </Button>
            <div
              style={{
                marginTop: token.marginLG,
                textAlign: "center",
                width: "100%",
              }}
            >
              <Text
                style={{
                  color: token.colorTextSecondary,
                }}
              >
                Don't have an account?
              </Text>{" "}
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  navigate("/signup");
                }}
                href="/signup"
                style={{
                  textDecorationLine: "underline",
                  color: token.colorPrimary,
                }}
              >
                Sign up now
              </Link>
            </div>
          </Form.Item>

          <>
            <Flex align="center" gap="24px">
              <Divider style={{ maxWidth: "126px", minWidth: "unset" }} />
              <Text style={{ whiteSpace: "nowrap" }}>OR</Text>
              <Divider style={{ maxWidth: "126px", minWidth: "unset" }} />
            </Flex>

            <SignInGoogle />
          </>
        </Form>
      </div>
    </div>
  );
}

export function SvgLogo() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.464294" width="24" height="24" rx="4.8" fill="#1890FF" />
      <path d="M14.8643 3.6001H20.8643V9.6001H14.8643V3.6001Z" fill="white" />
      <path d="M10.0643 9.6001H14.8643V14.4001H10.0643V9.6001Z" fill="white" />
      <path
        d="M4.06427 13.2001H11.2643V20.4001H4.06427V13.2001Z"
        fill="white"
      />
    </svg>
  );
}
